var map = {
	"./license-CC BY-NC-ND.png": "da54",
	"./license-CC BY-NC-SA.png": "6ce3",
	"./license-CC BY-NC.png": "6611",
	"./license-CC BY-ND.png": "f0a8",
	"./license-CC BY-SA.png": "ec5d",
	"./license-CC BY.png": "a78c",
	"./license-CC0.png": "519b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "93e4";